import moment from 'moment-timezone';
import { defaultAgent, apiResponse } from '../helpers/web-agent';
import { toastError } from './toast';
import { tokenExpired } from './auth';
import { isElasticLoad, isUUID } from '../helpers/common';
import { RECORD_FOUND } from '../constants/messages';
import { RANGE_TYPE_CUSTOM, HARVESTING_PLAN_TYPE_ID } from '../constants';
import * as actionTypes from '../constants/action-types';

//COMMON
export const setFarmId = (farmId) => ({ type: actionTypes.FARM_MONITOR_SET_FARM_ID, farmId });

export const setPlanTypeTypeId = (planTypeId) => ({ type: actionTypes.FARM_MONITOR_SET_PLAN_TYPE_ID, payload: planTypeId });

export const addRequestId = (requestId) => ({ type: actionTypes.FARM_MONITOR_ADD_REQUEST_ID, requestId });

export const clearRequestIds = () => ({ type: actionTypes.FARM_MONITOR_CLEAR_REQUEST_IDS });

export const clearFarmMonitor = () => ({ type: actionTypes.CLEAR_FARM_MONITOR });

export const refreshFarmMonitor = () => ({ type: actionTypes.FARM_MONITOR_REFRESH });

export const setSummaryCollapsed = payload => ({ type: actionTypes.FARM_MONITOR_SET_SUMMARY_TOGGLE_COLLAPSE, payload });

export const setWorkedRangeType = payload => ({ type: actionTypes.FARM_MONITOR_SET_WORKED_ACRES_RANGE_TYPE, payload });

//WORKED DETAILS
export const summaryRequest = (planTypeId) => ({ type: actionTypes.FARM_MONITOR_GET_SUMMARY_REQUEST, planTypeId });

export const summaryInfo = (planTypeId, payload) => ({ type: actionTypes.FARM_MONITOR_GET_SUMMARY, planTypeId, payload });

export const graphRequest = (planTypeId) => ({ type: actionTypes.FARM_MONITOR_GET_GRAPH_REQUEST, planTypeId });

export const graphInfo = (planTypeId, payload) => ({ type: actionTypes.FARM_MONITOR_GET_GRAPH, planTypeId, payload });

export const loadsSummaryRequest = () => ({ type: actionTypes.FARM_MONITOR_LOADS_SUMMARY_REQUEST });

export const loadsSummary = payload => ({ type: actionTypes.FARM_MONITOR_LOADS_SUMMARY, payload });

export const workedKPIRequest = (planTypeId, elasticType) => ({ type: actionTypes.FARM_MONITOR_GET_WORKED_KPI_REQUEST, planTypeId, elasticType });

export const workedKPI = (planTypeId, elasticType, elastic) => ({ type: actionTypes.FARM_MONITOR_GET_WORKED_KPI, planTypeId, elasticType, elastic });

export const subscribeFarmAnalyseKPI = (params) => ({ type: actionTypes.FARM_MONITOR_SUBSCRIBE_FARM_ANALYSE_KPI, params });

export const unsubscribeFarmAnalyseKPI = clearMessages => ({ type: actionTypes.FARM_MONITOR_UNSUBSCRIBE_FARM_ANALYSE_KPI, clearMessages });

//WORKED FIELD DETAILS
export const regionListRequest = () => ({ type: actionTypes.FARM_MONITOR_GET_REGION_LIST_REQUEST });

export const regionList = (data) => ({ type: actionTypes.FARM_MONITOR_GET_REGION_LIST, payload: data });

export const fieldEquipmentGroupListRequest = (haveRequest = true) => ({ type: actionTypes.FARM_MONITOR_GET_EG_LIST_REQUEST_FOR_FIELD, haveRequest });

export const fieldEquipmentGroupList = data => ({ type: actionTypes.FARM_MONITOR_GET_EG_LIST_FOR_FIELD, payload: data });

export const workedAcresRequest = () => ({ type: actionTypes.FARM_MONITOR_GET_WORKED_ACRES_REQUEST });

export const workedAcres = (data) => ({ type: actionTypes.FARM_MONITOR_GET_WORKED_ACRES, payload: data });

export const egWorkedAcresRequest = () => ({ type: actionTypes.FARM_MONITOR_GET_EG_WORED_ACRES_REQUEST });

export const egWorkedAcres = (data) => ({ type: actionTypes.FARM_MONITOR_GET_EG_WORED_ACRES, payload: data });

export const fieldLoadRequest = () => ({ type: actionTypes.FARM_MONITOR_GET_FIELD_LOADS_REQUEST });

export const fieldLoads = payload => ({ type: actionTypes.FARM_MONITOR_GET_FIELD_LOADS, payload });

//Q APP
export const deviceListRequest = () => ({ type: actionTypes.FARM_MONITOR_GET_DEVICE_LIST_REQUEST });

export const deviceList = payload => ({ type: actionTypes.FARM_MONITOR_GET_DEVICE_LIST, payload });

export const deviceSensorsRequest = () => ({ type: actionTypes.FARM_MONITOR_GET_DEVICE_SENSORS_REQUEST });

export const deviceSensors = payload => ({ type: actionTypes.FARM_MONITOR_GET_DEVICE_SENSORS, payload });

export const subscribeEgDeviceKPI = payload => ({ type: actionTypes.FARM_MONITOR_SUBSCRIBE_EG_DEVICE_KPI, payload });

export const unsubscribeEgDeviceKPI = () => ({ type: actionTypes.FARM_MONITOR_UNSUBSCRIBE_EG_DEVICE_KPI });

export const egDeviceKPILiveMessage = (deviceId, payload) => ({ type: actionTypes.FARM_MONITOR_EG_DEVICE_KPI_LIVE_MESSAGE, deviceId, payload });

//COMMON
export const cancelPreviousFarmMonitorRequest = () => (_, getState) => {
    const requestIds = getState().farmMonitor.requestIds;
    requestIds.forEach(id => defaultAgent.cancel(`farm_monitor_${id}`));
}

//WORKED DETAILS
export const getFarmSummary = (params, cb = null) => dispatch => {
    const reqParams = {
        farm_uuid: params.farmId,
        range_type: params.range,
        plan_type_id: params.planTypeId
    };

    const done = response => {
        dispatch(summaryInfo(params.planTypeId, response));
        dispatch(callKPI(params));
        return cb ? cb() : null;
    };

    if (params.range === RANGE_TYPE_CUSTOM) {
        if (!params.fromDate || !params.toDate) return done();
        reqParams.from_date = params.fromDate;
        reqParams.to_date = params.toDate;
    }

    const requestId = `summary_analyse_${params.planTypeId}`
    dispatch(addRequestId(requestId));

    dispatch(summaryRequest(params.planTypeId));
    defaultAgent.get(`/api/plan/v1/summary`, reqParams, { requestId: `farm_monitor_${requestId}` })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                done();
            } else if (agentResult.data) {
                done(agentResult.data);
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log('Farm monitor summary analyse: ', ex.message);
            dispatch(toastError(ex.message));
            return done();
        });
}

export const getFarmGraph = (params) => dispatch => {
    const reqParams = {
        farm_uuid: params.farmId,
        range_type: params.range,
        plan_type_id: params.planTypeId
    };

    if (params.range === RANGE_TYPE_CUSTOM) {
        if (!params.fromDate || !params.toDate) return dispatch(graphInfo(params.planTypeId));
        reqParams.from_date = params.fromDate;
        reqParams.to_date = params.toDate;
    }

    const requestId = `graph_analyse_${params.planTypeId}`
    dispatch(addRequestId(requestId));

    dispatch(graphRequest(params.planTypeId));
    defaultAgent.get(`/api/plan/v1/chart`, reqParams, { requestId: `farm_monitor_${requestId}` })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(graphInfo(params.planTypeId));
            } else if (agentResult.data) {
                dispatch(graphInfo(params.planTypeId, agentResult.data));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log('Farm monitor graph analyse: ', ex.message);
            dispatch(toastError(ex.message));
            dispatch(graphInfo(params.planTypeId));
        });
}

export const callKPI = (params) => dispatch => {
    dispatch(getWorkedKPI(params));
    if (isElasticLoad() && params.planTypeId === HARVESTING_PLAN_TYPE_ID) dispatch(getAutomaticLoad(params));
    return;
};

export const getWorkedKPI = params => dispatch => {
    if (!(params.fromDate && params.toDate)) return dispatch(workedKPI(params.planTypeId, "work"));;
    const reqParams = {
        farm_uuid: params.farmId,
        start_date: moment.utc(params.fromDate).startOf('day').format(),
        end_date: moment.utc(params.toDate).endOf('day').format()
    };

    const requestId = `farm_analyse_kpi_work_data_${params.farmId}_${params.planTypeId}`;
    dispatch(addRequestId(requestId));

    dispatch(workedKPIRequest(params.planTypeId, "work"));
    defaultAgent.post(`api/farm/kpi/data`, reqParams, { requestId: `farm_monitor_${requestId}` })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(workedKPI(params.planTypeId, "work"));
                dispatch(toastError(agentResult.message));
            } else if (agentResult.data) {
                const elastic = { isLive: false, data: agentResult.data };
                dispatch(workedKPI(params.planTypeId, "work", elastic));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log('Farm monitor analyse work KPI Data: ', ex.message);
            dispatch(toastError(ex.message));
            dispatch(workedKPI(params.planTypeId, "work"));
        });
}


export const getAutomaticLoad = params => dispatch => {
    if (!(params.fromDate && params.toDate)) return dispatch(workedKPI(params.planTypeId, "load"));
    const reqParams = {
        farm_uuid: params.farmId,
        start_date: moment.utc(params.fromDate).startOf('day').format(),
        end_date: moment.utc(params.toDate).endOf('day').format()
    };

    const requestId = `farm_analyse_kpi_load_data_${params.farmId}_${params.planTypeId}`;
    dispatch(addRequestId(requestId));

    dispatch(workedKPIRequest(params.planTypeId, "load"));
    defaultAgent.get(`api/farm/load/estimate/summary`, reqParams, { requestId: `farm_monitor_${requestId}` })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(workedKPI(params.planTypeId, "load"));
                dispatch(toastError(agentResult.message));
            } else if (agentResult.data) {
                const elastic = { isLive: false, data: agentResult.data };
                dispatch(workedKPI(params.planTypeId, "load", elastic));;
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log('Farm monitor analyse load KPI data: ', ex.message);
            dispatch(toastError(ex.message));
            dispatch(workedKPI(params.planTypeId, "load"));
        });
};

//WORKED FIELD DETAILS
export const getGeoRegionList = (params, cb) => dispatch => {
    const requestId = `region_list`;
    dispatch(addRequestId(requestId));

    dispatch(regionListRequest());
    defaultAgent.get('/api/geo/region/list', { farm_uuid: params.farmId }, { requestId: `farm_monitor_${requestId}` })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(regionList([]));
                dispatch(toastError(agentResult.message));
            }
            else if (agentResult.data) {
                dispatch(regionList(agentResult.data));
                if (cb) cb();
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(`Farm monitor region list data: `, ex.message);
            dispatch(toastError(ex.message));
            dispatch(regionList([]));
        });
}

export const getFieldEquipmentGroupList = (params, cb = null) => (dispatch) => {
    let dateInfo = {
        from: "2015-01-01T00:00:00.000Z",
        to: moment.utc().endOf('day').format()
    };

    const reqParams = {
        farm_uuid: params.farmId,
        from_date: dateInfo.from,
        to_date: dateInfo.to,
        crew: (params.crew || 1),
        device: (params.device || 1)
    };

    const requestId = `field_equipment_group_list`;
    dispatch(addRequestId(requestId));

    dispatch(fieldEquipmentGroupListRequest());
    defaultAgent.get('/api/equipment/group/v1/list', reqParams, { requestId: `farm_monitor_${requestId}` })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(fieldEquipmentGroupList());
            } else if (agentResult.data) {
                if (!!cb) cb(agentResult.data)
                dispatch(fieldEquipmentGroupList(agentResult.data));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(`Farm monitor Fields Equipment group data: `, ex.message);
            dispatch(toastError(ex.message));
            dispatch(fieldEquipmentGroupList());
        });
}
export const getWorkedAcres = (params) => (dispatch) => {
    const { farmId, fromDate, toDate, haveRequest } = params;
    if (!(fromDate && toDate)) return dispatch(workedAcres());;

    let reqParams = {
        farm_uuid: farmId,
        include_grid: true,
        start_date: moment.utc(fromDate).startOf('day').format(),
        end_date: moment.utc(toDate).endOf('day').format()
    };

    const requestId = `farm_shape_info_${farmId}`;
    dispatch(addRequestId(requestId));

    if (haveRequest) dispatch(workedAcresRequest());

    defaultAgent.post(`/api/farm/region-covered`, reqParams, { requestId: `farm_monitor_${requestId}`, timeout: 2 * 60 * 1000 })
        .then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.status === 'error') {
                dispatch(workedAcres());
                dispatch(toastError(agentResult.message));
            }
            else if (agentResult.code === RECORD_FOUND.code) {
                dispatch(workedAcres(agentResult.data));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(`Farm monitor farm shape info: `, ex.message);
            dispatch(toastError(ex.message));
            dispatch(workedAcres());
        });
}

export const getEGWorkedAcres = (params) => (dispatch) => {
    const { haveRequest, farmId, fromDate, toDate } = params;
    if (!(fromDate && toDate)) return dispatch(egWorkedAcres());;

    let reqParams = {
        farm_uuid: farmId,
        include_grid: true,
        start_date: moment.utc(fromDate).startOf('day').format(),
        end_date: moment.utc(toDate).endOf('day').format()
    };

    const requestId = `equipment_group_shape_info_${farmId}`;
    dispatch(addRequestId(requestId));

    if (haveRequest) dispatch(egWorkedAcresRequest());

    defaultAgent.post(`/api/equipment/group/region-covered`, reqParams, { requestId: `farm_monitor_${requestId}`, timeout: 2 * 60 * 1000 })
        .then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.status === 'error') {
                dispatch(egWorkedAcres());
                dispatch(toastError(agentResult.message));
            }
            else if (agentResult.code === RECORD_FOUND.code) {
                dispatch(egWorkedAcres(agentResult.data));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(`Farm monitor equipment group shape info : `, ex.message);
            dispatch(toastError(ex.message));
            dispatch(egWorkedAcres());
        });
}

export const getLoadHistory = params => (dispatch) => {
    if (!params.range) return;
    isElasticLoad() ? dispatch(getAutomaticLoadsForField(params)) : dispatch(getManualLoadsForField(params));
};

export const getAutomaticLoadsForField = params => (dispatch) => {
    if (!(params.fromDate && params.toDate)) return fieldLoads();

    const reqParams = {
        farm_uuid: params.farmId,
        start_date: moment.utc(params.fromDate).startOf('day').format(),
        end_date: moment.utc(params.toDate).endOf('day').format()
    };

    const requestId = `LoadEstimateRegionSummary`;
    dispatch(addRequestId(requestId));

    if (params.haveRequest) dispatch(fieldLoadRequest());
    defaultAgent.post(`/api/farm/load/estimate/region/summary`, reqParams, { requestId: `farm_monitor_${requestId}` })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(fieldLoads());
            } else {
                const fieldLoadsById = agentResult.data && agentResult.data.data ? agentResult.data.data : {};
                const loads = Object.keys(fieldLoadsById).map(id => ({
                    shapeRefId: id,
                    loads: fieldLoadsById[id].load_count || 0
                }));
                dispatch(fieldLoads(loads));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(`Farm monitor equipment group load estimate summary: `, ex.message);
            dispatch(toastError(ex.message));
            dispatch(fieldLoads());
        });
};

export const getManualLoadsForField = params => (dispatch) => {
    const reqParams = {
        farm_uuid: params.farmId,
        range_type: params.range,
        plan_type_id: params.planTypeId
    };

    if (params.range === RANGE_TYPE_CUSTOM) {
        if (!params.fromDate || !params.toDate) {
            dispatch(loadsSummary());
            dispatch(fieldLoads());
            return;
        }
        reqParams.from_date = params.fromDate;
        reqParams.to_date = params.toDate;
    }

    const requestId = `LoadHistoryForField`;
    dispatch(addRequestId(requestId));

    if (params.haveRequest) dispatch(fieldLoadRequest());
    defaultAgent.get(`/api/plan/load/v1/history`, reqParams, { requestId: `farm_monitor_${requestId}` })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(loadsSummary());
                dispatch(fieldLoads());
            } else if (agentResult.data) {
                dispatch(loadsSummary(agentResult.data ? agentResult.data.load : null));
                const loadList = (agentResult.data.history || [])
                    .filter(e => isUUID(e.field_geo_shape_uuid) /* && e.transfer_type === 1 */);

                const fieldsById = loadList.reduce((objById, item) => {
                    const shapeId = item.field_geo_shape_uuid;
                    const prevLoads = objById[shapeId] ? objById[shapeId].loads : 0;
                    const prevLoadCapacity = objById[shapeId] ? objById[shapeId].loadCapacity : 0;
                    objById[shapeId] = { loads: prevLoads + 1, loadCapacity: prevLoadCapacity + item.load_capacity };
                    return objById;
                }, {});

                const loads = Object.keys(fieldsById).map(id => ({ shapeRefId: id, ...fieldsById[id] }));
                dispatch(fieldLoads(loads));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(`Farm monitor load history for field: `, ex.message);
            dispatch(toastError(ex.message));
            dispatch(loadsSummary());
            dispatch(fieldLoads());
        });
};

//Q APP
export const getDeviceList = params => dispatch => {
    const { farmId } = params;

    const reqParams = {
        farm_uuid: farmId,
        crew: 0,
        device: 1,
        from_date: moment.utc().startOf('day').format(),
        to_date: moment.utc().endOf('day').format()
    };

    const requestId = `device_eglist`;
    dispatch(addRequestId(requestId));

    dispatch(deviceListRequest());
    defaultAgent.get('/api/equipment/group/v1/list', reqParams, { requestId: `farm_monitor_${requestId}` })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(deviceList());
            } else if (agentResult.data) {
                const filteredDeviceList = agentResult.data.filter(item => item.phone_device.device_uuid ? true : false);
                const deviceById = {};
                filteredDeviceList.forEach(item => deviceById[item.phone_device.device_uuid] = {
                    deviceId: item.phone_device.device_uuid,
                    deviceName: item.phone_device.name,
                    equipmentGroupId: item.equipment_group_uuid,
                    equipmentGroupName: item.equipment_group_name,
                    isTruck: item.vehicle.is_truck,
                    planTypeId: item.plan_type_id
                });
                dispatch(deviceList(deviceById));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log('Farm Monitor Device EG List: ', ex.message);
            dispatch(toastError(ex.message));
            dispatch(deviceList());
        });
};

export const getDeviceSensors = egListWithDeviceId => dispatch => {
    const params = {
        equipment_group_uuid: egListWithDeviceId.map(item => item.equipmentGroupId).join(","),
        sensor: 'battery_level,q_connection,pto,fuel_level'
    }
    const requestId = `device_sensor_data`;
    dispatch(addRequestId(requestId));

    dispatch(deviceSensorsRequest());
    defaultAgent.post('/api/equipment/group/sensor/latest', params, { requestId: `farm_monitor_${requestId}` })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(deviceSensors());
            } else if (agentResult.data) {
                const getSensorData = (sensors, sensorName, isDeleteDevice = true) => {
                    const sensorData = sensors && sensors[sensorName] && sensors[sensorName].data
                        && Object.keys(sensors[sensorName].data).length > 0 ? sensors[sensorName].data : null;
                    if (!sensorData) return sensorData;
                    if (!isDeleteDevice) return sensorData;

                    if (sensorData.device_id) delete sensorData.device_id;
                    if (sensorData.device_uuid) delete sensorData.device_uuid;

                    return sensorData;
                }
                const sensorDataById = {};

                egListWithDeviceId.forEach(item => {
                    const sensors = agentResult.data[item.equipmentGroupId];
                    sensorDataById[item.deviceId] = {
                        battery: getSensorData(sensors, "battery_level"),
                        qConnection: getSensorData(sensors, "q_connection"),
                        pto: getSensorData(sensors, "pto"),
                        fuelLevel: getSensorData(sensors, "fuel_level")
                    }
                })
                dispatch(deviceSensors(sensorDataById));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log('Farm Monitor Device sensor data: ', ex.message);
            dispatch(toastError(ex.message));
            dispatch(deviceSensors());
        });
}
